// Analytics Component - Tracks page views on route change
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/ga4';

export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname + location.search, document.title);
    
    // Also track in our internal analytics
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    if (API_URL) {
      fetch(`${API_URL}/api/analytics/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event_type: 'page_view',
          details: {
            path: location.pathname,
            search: location.search,
            referrer: document.referrer
          }
        })
      }).catch(() => {}); // Silent fail for analytics
    }
  }, [location]);

  return null; // This component doesn't render anything
};

export default Analytics;
